import { render } from "./ImageSelector.vue?vue&type=template&id=f64e921c&scoped=true"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"

import "./ImageSelector.vue?vue&type=style&index=0&id=f64e921c&scoped=true&lang=css"

import exportComponent from "/var/www/eventgallery/build/tmpBuildDir/components/com_eventgallery/media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64e921c"],['__file',"backend/vue/imagecontentpluginform/ImageSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f64e921c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f64e921c', __exports__)) {
    api.reload('f64e921c', __exports__)
  }
  
  module.hot.accept("./ImageSelector.vue?vue&type=template&id=f64e921c&scoped=true", () => {
    api.rerender('f64e921c', render)
  })

}


export default __exports__